import goods from './goods'
import categories from './categories'
import orders from './orders'

export default {
  shop: {
    namespaced: true,
    modules: {
      goods,
      categories,
      orders
    },
  },
}
